import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import AddRemoveStockModal from "./add_remove_stock_modal";

const AddRemoveStock = ({ inventory }) => {
  const [isModalActive, setModalActive] = useState(false);
  const buttonId = `add_remove_stock_${inventory.id}`;

  const openModal = () => setModalActive(true);
  const closeModal = () => {
    setModalActive(false);
    window.requestAnimationFrame(() => document.getElementById(buttonId)?.focus());
  };
  useEffect(() => {
    const button = document.getElementById(buttonId);
    const handleClick = (event) => {
      event.preventDefault();
      openModal();
    };
    button?.addEventListener("click", handleClick);
    return () => {
      button?.removeEventListener("click", handleClick);
    };
  }, [buttonId]);

  if (isModalActive) {
    return <AddRemoveStockModal inventory={inventory} closeModal={closeModal} />;
  }
  return null;
};

AddRemoveStock.propTypes = {
  inventory: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
    quantity: PropTypes.number.isRequired,
    description: PropTypes.string.isRequired,
    updated_at: PropTypes.string.isRequired
  })
};

export default AddRemoveStock;
